import classNames from "classnames";
import { RELEASE_HASH } from "config/envConfig";
import React, { useMemo } from "react";

import styles from "./style.module.css";

const SVGIcon = ({ className, src, alt = "", small, ...rest }) => {
  const imageSrc = useMemo(() => {
    try {
      new URL(src);

      return src;
    } catch (error) {
      return `/assets/${src}?release=${RELEASE_HASH}`;
    }
  }, [src]);

  return (
    <img
      {...rest}
      className={classNames(small ? styles.containerSmall : styles.container, className)}
      src={imageSrc}
      loading="lazy"
      alt={alt || imageSrc}
    />
  );
};

export default SVGIcon;
